var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-question_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-1c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.92 5.83v.12c0 .7-.28 1.16-1.293 2.08-.627.56-.713.787-.713 1.24 0 .32-.294.527-.627.527-.353 0-.653-.173-.653-.56 0-.753.12-1.153.893-1.827.893-.773 1.013-1.013 1.013-1.44v-.053c0-.453-.313-.853-1.16-.853-.573 0-.98.193-1.366.46-.28.193-.58.12-.787-.154-.207-.26-.207-.626.073-.84.527-.406 1.227-.686 2.12-.686 1.56 0 2.5.82 2.5 1.993zM9.1 11.337c0 .46-.353.82-.82.82a.803.803 0 0 1-.82-.82c0-.467.354-.82.82-.82.467 0 .82.353.82.82"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-question_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h16v16H.5z"
})))));
export default SvgIcQuestion;